<div class="kpi-summary">
  <div *ngFor="let column of kpisColumns" [id]="column.columnId" class="kpi-column">
    <span>{{ column.header }}</span> {{ kpisValue | dataCellFormatter: column }}
  </div>

  <mat-icon
    *ngIf="showInfoIcon"
    id="e2e-kpi-summary-inof-icon"
    class="info-icon"
    matTooltipPosition="above"
    svgIcon="circle-info-icon"
    [matTooltip]="'shared.kpiSummary' | xTranslate: { limit }"
  ></mat-icon>
</div>
